import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import { Layout, Menu } from 'antd';
import { withBreakpoints } from 'react-breakpoints';
import Logo from '../../components/Logo';
import IconSvg from '../../components/common/IconSvg';
import { buttonNormal, buttonHover } from '../../constants/themes';

const { Sider: AntSider } = Layout;

const MenuItemContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const StyledMenuItem = styled(Menu.Item)`
  height: 75px !important;
  width: 100% !important;
  align-items: center;
  justify-content: center;
  align-self: center;
  justify-items: center;
  justify-self: center;
  align-content: center;
  vertical-align: middle;
  display: flex;
  flex-direction: column;
  margin-top: 0;
  margin-bottom: 0;
`;

const StyledMenu = styled(Menu)`
  //   display: flex;
  //   flex-direction: column;
  //   justify-content: space-around;
  height: calc(100vh - 68px);
  ${({ fontSize }) =>
    fontSize
      ? `
  .ant-menu-item div {
    font-size: ${fontSize};
  }`
      : ''}
`;

@inject('routingStore')
@inject('localeStore')
@inject('notificationsStore')
@observer
class BifmSider extends Component {
  static propTypes = {
    routingStore: PropTypes.object,
    localeStore: PropTypes.object,
    notificationsStore: PropTypes.object,
  };

  componentDidMount() {
    const { routingStore } = this.props;
    routingStore.setRouteMainPathForBifm();
    routingStore.browserHistory.listen(() => {
      routingStore.setRouteMainPathForBifm();
    });
  }

  updateRouteState = path => {
    const {
      routingStore,
      notificationsStore: { fetchFirstPage },
    } = this.props;
    fetchFirstPage();
    if (window.location.pathname === path) {
      switch (path) {
        case '/orders/table': {
          routingStore.reloadOrders();
          break;
        }
        default: {
          break;
        }
      }
    }
    routingStore.browserHistory.push(path);
  };

  render() {
    const {
      routingStore: { routeMainPathForBIFM },
      localeStore: { isBG, isFR },
    } = this.props;

    const { mobileLayout } = this.props;

    return (
      <AntSider
        css={{ backgroundColor: '#ffffff', overflow: 'hidden', position: !mobileLayout && 'fixed' }}
        width="118px"
      >
        {!mobileLayout && <Logo onClick={() => this.updateRouteState('/externalOrders/table')} />}
        <StyledMenu
          mode="inline"
          defaultOpenKeys={[routeMainPathForBIFM]}
          selectedKeys={[routeMainPathForBIFM]}
          fontSize={isBG || isFR ? '10px' : null}
        >
          <StyledMenuItem
            key="externalOrders"
            onClick={() => this.updateRouteState('/externalOrders/table')}
          >
            <MenuItemContainer>
              <IconSvg type="orders" color={buttonNormal} hoverColor={buttonHover} size={20} />
              <FormattedMessage id="common.orders" />
            </MenuItemContainer>
          </StyledMenuItem>
          <StyledMenuItem key="reports" onClick={() => this.updateRouteState('/reports')}>
            <MenuItemContainer>
              <IconSvg type="reports" color={buttonNormal} hoverColor={buttonHover} size={20} />
              <FormattedMessage id="common.reports" />
            </MenuItemContainer>
          </StyledMenuItem>
        </StyledMenu>
      </AntSider>
    );
  }
}
export default withBreakpoints(BifmSider);
